import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

/** @category useChangePassword */
export type TypeChangePwParams = {
  /** 현재 비밀번호 */
  currentPassword: string;
  /** 새 비밀번호 */
  newPassword: string;
};

/** @category useChangePassword */
export type TypeChangePwResponse = {
  /** 응답 메시지 */
  message: string;
};

/**
 * @description 비밀번호를 재설정하는 api 요청에 사용되는 커스텀 훅
 */
export const useChangePassword = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeChangePwParams) => {
      const endpoint = '/labor-accounts/modify-password/me';
      return axiosInstance.post<TypeChangePwResponse>(endpoint, params);
    },
  });

  const requestChangePw = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeChangePwParams;
    onSuccess?: (res: TypeChangePwResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestChangePw;
};
